import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/redirect/:path*',
    component: () => import('@/views/redirect/index')
  },
  {
    path: '/piggery',
    name: 'piggery',
    component: () => import('@/views/service-solution/piggery')
  },
  {
    path: '/EPC',
    name: 'EPC',
    component: () => import('@/views/service-solution/EPC')
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/service-solution/finance')
  },
  {
    path: '/cloud',
    name: 'cloud',
    component: () => import('@/views/service-solution/cloud')
  },
  // {
  //   path: '/iot',
  //   name: 'iot',
  //   component: () => import('@/views/service-solution/iot')
  // },
  {
    path: '/iotDetail',
    name: 'iotDetail',
    component: () => import('@/views/service-solution/iot-detail')
  },
  {
    path: '/groupEdition',
    name: 'groupEdition',
    component: () => import('@/views/core-competence/group-edition')
  },
  {
    path: '/coreCompetence',
    name: 'coreCompetence',
    component: () => import('@/views/core-competence/index')
  },
  {
    path: '/caseExample',
    name: 'caseExample',
    component: () => import('@/views/case-example')
  },
  {
    path: '/campanyNews',
    name: 'campanyNews',
    component: () => import('@/views/info-center/campany-news')
  },
  {
    path: '/newsDetail/:id',
    name: 'campanyNewsDetail',
    component: () => import('@/views/info-center/campany-news-detail')
  },
  {
    path: '/pigNews',
    name: 'pigNews',
    component: () => import('@/views/info-center/pig-news')
  },
  {
    path: '/pigDetail/:id',
    name: 'pigNewsDetail',
    component: () => import('@/views/info-center/pig-news-detail')
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: () => import('@/views/about-nx/join-us')
  },
  {
    path: '/companyIntro',
    name: 'companyIntro',
    component: () => import('@/views/about-nx/company-intro')
  },
  {
    path: '/piggerySpecialist',
    name: 'piggerySpecialist',
    component: () => import('@/views/about-nx/piggery-specialist')
  },
  {
    path: '/consult',
    name: 'consult',
    component: () => import('@/views/core-competence/index')
  },
  {
    path: '/productCenter',
    name: 'productCenter',
    meta: { headType: 'black' },
    component: () => import('@/views/product/product-center')
  },
  {
    path: '/softwareCenter',
    name: 'softwareCenter',
    meta: { headType: 'black' },
    component: () => import('@/views/product/software-center')
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    meta: { headType: 'black' },
    component: () => import('@/views/product/product-detail')
  },
  {
    path: '/systemDetail',
    name: 'systemDetail',
    meta: { headType: 'black' },
    component: () => import('@/views/product/system-detail')
  },
  {
    path: '/productCompare',
    name: 'productCompare',
    meta: { headType: 'black' },
    component: () => import('@/views/product/product-compare')
  },
  {
    path: '/productDevType',
    name: 'productDevType',
    meta: { headType: 'black' },
    component: () => import('@/views/product/product-dev-type')
  },
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    meta: { headType: 'black' },
    component: () => import('@/views/product/shopping-cart')
  }
]
const router = new VueRouter({
  routes
})

export default router
